import React, { useRef, useState } from 'react';
import { Play } from 'lucide-react';
import { alignerReviewVideo } from '../data/testimonialVideos';
import { trackEvent } from '../utils/analytics';
type TestimonialVideoPlayerProps = {
  /** Accessible name for the video. */
  ariaLabel: string;
  /** Visible label on the play button. */
  playLabel: string;
  analyticsPage: string;
  analyticsPosition: string;
  className?: string;
};

/**
 * 4:5 testimonial video. Shows an early frame as a light cover (only metadata is fetched),
 * then plays from the start with sound after an explicit click or tap.
 * No autoplay or loop; native controls (play/pause, seek, volume, fullscreen) appear once started.
 */
export function TestimonialVideoPlayer({
  ariaLabel,
  playLabel,
  analyticsPage,
  analyticsPosition,
  className = ''
}: TestimonialVideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [started, setStarted] = useState(false);
  const handleStart = () => {
    const el = videoRef.current;
    if (!el) return;
    setStarted(true);
    el.currentTime = 0;
    el.muted = false;
    el.play().catch(() => undefined);
    trackEvent('video_play', {
      page: analyticsPage,
      position: analyticsPosition
    });
  };
  return <div className={`relative aspect-[4/5] rounded-2xl overflow-hidden shadow-xl bg-forest-900 ${className}`} data-id="element-672" data-mp="3nwwtfyk1j40b">
      <video ref={videoRef} src={`${alignerReviewVideo.src}#t=${alignerReviewVideo.posterTimeSeconds}`} preload="metadata" playsInline controls={started} aria-label={ariaLabel} className="absolute inset-0 w-full h-full object-contain" data-id="element-673" data-mp="3jvuqb6n067t2" />
      {!started && <button type="button" onClick={handleStart} className="group absolute inset-0 flex items-end justify-center pb-6 sm:pb-8 bg-forest-900/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-white" data-id="element-674" data-mp="6f3viqas8mfs">
          <span className="inline-flex items-center gap-2.5 rounded-full bg-white px-4 sm:px-5 min-h-[48px] text-sm sm:text-base font-medium text-forest-900 shadow-lg whitespace-nowrap transition-transform duration-150 ease-out group-hover:scale-[1.03] group-active:scale-[0.98]" data-id="element-675" data-mp="397rz43a3h3a9">
            <span className="w-8 h-8 rounded-full bg-forest-600 flex items-center justify-center flex-shrink-0" data-id="element-676" data-mp="3i6de5ogcy06a">
              <Play className="w-4 h-4 text-white ml-0.5 fill-current" aria-hidden="true" data-id="element-677" data-mp="3rxzufz7jypfw" />
            </span>
            {playLabel}
          </span>
        </button>}
    </div>;
}